<template>
    <div
        class="profession-wrapper"
        :class="{ _phone: phoneAndLess }"
    >
        <div class="profession-content">
            <div
                class="profession-wrapper-overlay"
                v-if="headingDialog || chartDialog"
                @click="overlayClickHandler"
            />
            <h4 class="profession-subheading">Ваша цель</h4>
            <div
                class="profession-heading-wrapper"
                :class="{ _desktop: desktopAndMore, _tablet: tabletAndLess }"
            >
                <template v-if="simpleTitle">
                    <router-link
                        class="profession-heading"
                        :to="simpleTitle.link"
                    >
                        {{ simpleTitle.title }}
                    </router-link>
                </template>
                <template v-else>
                    <h3
                        class="profession-heading"
                        @click="tabletAndLess ? headingDialog = true : false"
                    >
                        {{complexTitle}}
                    </h3>
                </template>
                <GoalsPopup
                    v-if="showHeadingDialog"
                    class="profession-heading-details"
                    :class="{ _desktop: desktopAndMore, _tablet: tabletAndLess, _phone: phoneAndLess }"
                    @close="headingDialog = false"
                />
            </div>
            <template v-if="getSoftCompetences.length + getHardCompetences.length  > 0">
                <p class="profession-meta">Насколько выбранные программы приближают к выполнению цели</p>
                <div
                    class="profession-chart"
                    :class="{ _desktop: desktopAndMore, _tablet: tabletAndLess }"
                >
                    <div
                        v-if="getSoftCompetences.length"
                        class="profession-chart-soft"
                        @click="tabletAndLess ? chartDialog = true : false"
                    >
                        <h5 class="profession-chart-heading">Компетенции {{softPercentage || softPercentage === 0 ? `${softPercentage}%` : ''}}</h5>
                        <div class="profession-chart-bar">
                            <div class="profession-chart-bar-complete" :style="softSkillsStyle"/>
                        </div>
                    </div>
                    <div
                        v-if="getHardCompetences.length"
                        class="profession-chart-hard"
                        @click="tabletAndLess ? chartDialog = true : false"
                    >
                        <h5 class="profession-chart-heading">Профессиональные навыки {{hardPercentage || hardPercentage === 0 ? `${hardPercentage}%` : ''}}</h5>
                        <div class="profession-chart-bar">
                            <div class="profession-chart-bar-complete" :style="hardSkillsStyle"/>
                        </div>
                    </div>
                    <div
                        class="profession-chart-details-wrapper"
                        :class="{ _desktop: desktopAndMore, _tablet: tabletAndLess, _phone: phoneAndLess }"
                    >
                        <div
                            v-if="showChartDialog"
                            class="profession-chart-details"
                        >
                            <svg
                                v-if="tabletAndLess"
                                class="profession-heading-details-close"
                                width="28"
                                height="28"
                                @click="chartDialog = false"
                            >
                                <use xlink:href="#close"/>
                            </svg>
                            <template v-if="uniqueHardCompetences.length + uniqueSoftCompetences.length > 0">
                                <h6 class="profession-chart-details-heading">Обучение добавлено</h6>
                                <ul>
                                    <li
                                        class="profession-chart-details-soft"
                                        v-for="item in uniqueSoftCompetences"
                                        :key="item.id"
                                    >
                                        <router-link :to="item.publicationLink">
                                            {{ item.name }}
                                        </router-link>
                                    </li>
                                    <li
                                        class="profession-chart-details-hard"
                                        v-for="item in uniqueHardCompetences"
                                        :key="item.id"
                                    >
                                        <router-link :to="item.publicationLink">
                                            {{ item.name }}
                                        </router-link>
                                    </li>
                                </ul>
                            </template>
                            <template v-if="nonProgramSoftCompetences.length + nonProgramHardCompetences.length > 0">
                                <h6 class="profession-chart-details-heading">Обучение еще не подобрано</h6>
                                <ul>
                                    <li
                                        class="profession-chart-details-gray"
                                        v-for="item in nonProgramSoftCompetences"
                                        :key="item.id"
                                    >
                                        <router-link :to="item.publicationLink">
                                            {{ item.name }}
                                        </router-link>
                                    </li>
                                    <li
                                        class="profession-chart-details-gray"
                                        v-for="item in nonProgramHardCompetences"
                                        :key="item.id"
                                    >
                                        <router-link :to="item.publicationLink">
                                            {{ item.name }}
                                        </router-link>
                                    </li>
                                </ul>
                            </template>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import GoalsPopup from '../components/GoalsPopup';
const accountTrackGetters = [
    'getSoftCompetences',
    'getHardCompetences',
    'getUniqueProgramCompetences',
    'getProfessions',
    'getDirectSoftCompetences',
    'getDirectHardCompetences',
    'getHasMultipleGoals',
];

export default {
    name: 'Profession',
    components: {GoalsPopup},
    data: () => ({
        offsetSoftSkills: 100,
        offsetHardSkills: 100,
        headingDialog: false,
        chartDialog: false,
    }),
    computed: {
        ...mapGetters('accountTrack', accountTrackGetters),
        ...mapGetters(['width']),
        uniqueSoftCompetences() {
            const allTheSoftProgramCompetences = this.getUniqueProgramCompetences.filter(el => el.competenceType === 'soft');
            return this.getSoftCompetences.filter(el => allTheSoftProgramCompetences.find(unique => unique.id === el.id));
        },
        uniqueHardCompetences() {
            const allTheHardProgramCompetences = this.getUniqueProgramCompetences.filter(el => el.competenceType === 'hard');
            return this.getHardCompetences.filter(el => allTheHardProgramCompetences.find(unique => unique.id === el.id));
        },
        nonProgramSoftCompetences() {
            return this.getSoftCompetences.filter(el => !this.uniqueSoftCompetences.find(unique => unique.id === el.id));
        },
        nonProgramHardCompetences() {
            return this.getHardCompetences.filter(el => !this.uniqueHardCompetences.find(unique => unique.id === el.id));
        },
        softPercentage() {
            return 100 - Math.round(100 / (this.uniqueSoftCompetences.length + this.nonProgramSoftCompetences.length) * this.nonProgramSoftCompetences.length);
        },
        hardPercentage() {
            return 100 - Math.round(100 / (this.uniqueHardCompetences.length + this.nonProgramHardCompetences.length) * this.nonProgramHardCompetences.length);
        },
        softSkillsStyle() {
            return `transform: translateX(-${this.offsetSoftSkills}%)`;
        },
        hardSkillsStyle() {
            return `transform: translateX(-${this.offsetHardSkills}%)`;
        },
        simpleTitle() {
            if (this.getProfessions.length === 1 && !this.getDirectSoftCompetences.length && !this.getDirectSoftCompetences.length) {
                return {
                    title: `Профессия «${this.getProfessions[0].name}»`,
                    link: this.getProfessions[0].publicationLink,
                };
            } else if (!this.getProfessions.length && this.getDirectSoftCompetences.length === 1 && !this.getDirectHardCompetences.length) {
                return {
                    title: `Компетенция «${this.getDirectSoftCompetences[0].name}»`,
                    link: this.getDirectSoftCompetences[0].publicationLink,
                };
            } else if (!this.getProfessions.length && !this.getDirectSoftCompetences.length && this.getDirectHardCompetences.length === 1) {
                return {
                    title: `Проф. навык «${this.getDirectHardCompetences[0].name}»`,
                    link: this.getDirectHardCompetences[0].publicationLink,
                };
            }
            return null;
        },
        complexTitle() {
            const professions = this.getProfessions.length ? `профессии (${this.getProfessions.length})` : '';
            const softCompetences = this.getDirectSoftCompetences.length ? `компетенции (${this.getDirectSoftCompetences.length})` : '';
            const hardCompetences = this.getDirectHardCompetences.length ? `профессиональные навыки (${this.getDirectHardCompetences.length})` : '';
            if (professions) {
                return `${professions.charAt(0).toUpperCase() + professions.slice(1)}${softCompetences ? `, ${softCompetences}` : ''}${hardCompetences ? `, ${hardCompetences}` : ''}`;
            } else if (softCompetences) {
                return `${softCompetences.charAt(0).toUpperCase() + softCompetences.slice(1)}${hardCompetences ? `, ${hardCompetences}` : ''}`;
            } else if (hardCompetences) {
                return `${hardCompetences.charAt(0).toUpperCase() + hardCompetences.slice(1)}`;
            }
            return '';
        },
        desktopAndMore() {
            return this.width > 768;
        },
        tabletAndLess() {
            return this.width <= 768;
        },
        phoneAndLess() {
            return this.width <= 376;
        },
        showHeadingDialog() {
            if (this.tabletAndLess) {
                return this.headingDialog && this.getHasMultipleGoals;
            }
            return !this.simpleTitle;
        },
        showChartDialog() {
            if (this.tabletAndLess) {
                return this.chartDialog;
            }
            return true;
        },
    },
    watch: {
        softPercentage(v) {
            setTimeout(() => {
                this.offsetSoftSkills = 100 - v;
            }, 400);
        },
        hardPercentage(v) {
            setTimeout(() => {
                this.offsetHardSkills = 100 - v;
            }, 400);
        },
    },
    mounted() {
        setTimeout(() => {
            this.offsetSoftSkills = 100 - this.softPercentage;
            this.offsetHardSkills = 100 - this.hardPercentage;
        }, 400);
    },
    methods: {
        overlayClickHandler() {
            this.headingDialog = false;
            this.chartDialog = false;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';

.profession-wrapper {
    padding: 24px;
    height: 100%;
    background-color: #fff;
    border: 1px solid #D2D5D9;
    border-radius: 4px;
    &._phone {
        border-width: 0;
    }

    @include on-md {
        min-height: 264px;
    }

    @include on-xs {
        min-height: 80vh;
        border: none;
        box-shadow: 0 2px 8px rgba(155, 161, 166, 0.23626);
    }
}

.profession-content {
    width: 100%;

    @include on-md {
        width: 57%;
    }

    @include on-sm {
        width: 100%;
    }
}

.profession-wrapper-overlay {
    position: absolute;
    z-index: 9999;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(#000, 0.4);
}

.profession-subheading,
.profession-meta,
.profession-chart-heading {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #98A0A9;
}
.profession-subheading {
    margin: 0 0 8px;
}
.profession-meta {
    margin: 0 0 16px;
}
.profession-heading {
    margin: 0 0 20px;
    font-weight: 600;
    font-size: 28px;
    line-height: 36px;

    &:hover {
        color: #4663AB;
    }

    @include on-lg {
        font-size: 24px;
        line-height: 32px;
    }

    @include on-xs {
        font-size: 20px;
        line-height: 28px;
    }
}
.profession-heading-wrapper._desktop {
    position: relative;
}
.profession-heading-wrapper._desktop:hover > .profession-heading-details {
    display: block;
}
.profession-heading-wrapper._tablet > .profession-heading-details {
    z-index: 10000;
    display: block;
}
.profession-heading-details {
    position: absolute;
    z-index: 1;
    left: 0;
    right: 0;
    top: 100%;
    display: none;
    &._tablet {
        left: 32px;
        right: 32px;
        top: 96px;
    }
    &._phone {
        left: 16px;
        right: 16px;
    }
    ul {
        padding: 24px;
        margin: 8px 0 0;
        background-color: #FFFFFF;
        box-shadow: 0 2px 24px rgba(155, 161, 166, 0.6);
        border-radius: 4px;
    }
    li {
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        line-height: 26px;
        list-style: none;
        &:not(:last-child) {
            margin-bottom: 16px;
        }
    }
    li a {

    }
    li:hover,
    li a:hover {
        color: #4663AB;
    }
}

.profession-chart {
    &:hover {
        .profession-chart-heading {
            color: #4663AB;
        }
    }
}

.profession-chart._desktop {
    position: relative;
}
.profession-chart-heading {
    margin: 16px 0 0;
    font-weight: normal;
    color: #2A2626;
}
.profession-chart-bar,
.profession-chart-bar-complete {
    width: 100%;
    height: 10px;
    border-radius: 16px;
}
.profession-chart-bar {
    overflow: hidden;
    background-color: #F3F3F3;
}
.profession-chart-bar-complete {
    transition: transform 400ms ease-in;
    transform: translateX(-100%);
}
.profession-chart-soft .profession-chart-bar-complete {
    background-color: #8D7BFB;
}
.profession-chart-hard .profession-chart-bar-complete {
    background-color: #1AB2D3;
}

.profession-chart._desktop:hover > .profession-chart-details-wrapper {
    display: block;
}
.profession-chart._tablet > .profession-chart-details-wrapper {
    z-index: 10000;
    display: block;
}

.profession-chart-details-wrapper {
    display: none;
    position: absolute;
    z-index: 1;
    left: 0;
    right: 0;
    top: 100%;
    &._tablet {
        left: 32px;
        right: 32px;
        top: 96px;
        max-height: 60vh;
        overflow-y: scroll;
    }
    &._phone {
        left: 16px !important;
        right: 16px !important;
        .profession-chart-details {
            padding: 18px;
        }
    }
}
.profession-chart-details {
    @include custom-scroll-bar;
    overflow-y: auto;
    padding: 24px;
    margin-top: 16px;
    background-color: #FFFFFF;
    box-shadow: 0 2px 16px rgba(155, 161, 166, 0.4);
    border-radius: 4px;
    max-height: 330px;

    ul {
        padding: 16px 0 0;
        margin: 0;
        list-style:none;
        &:not(:last-child) {
            padding: 16px 0 24px;
        }
        li {
            padding-left: 24px;
            font-weight: normal;
            font-size: 15px;
            line-height: 22px;
            background-position-y: center;
            background: no-repeat left 3px;
            background-image: url("~@/assets/images/account-track/icon/competence-hover.svg");
            &:hover {
                background-image: url("~@/assets/images/account-track/icon/competence-hover.svg") !important;
                a {
                    color: #4663AB;
                }
            }
            &.profession-chart-details-soft {
                background-image: url("~@/assets/images/account-track/icon/competence-soft.svg");
            }
            &.profession-chart-details-hard {
                background-image: url("~@/assets/images/account-track/icon/competence-hard.svg");
            }
            &.profession-chart-details-gray {
                background-image: url("~@/assets/images/account-track/icon/competence.svg");
            }
        }
        li:not(:last-child) {
            margin-bottom: 16px;
        }
    }
}
.profession-chart-details-heading {
    margin: 0;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
}

.profession-heading-details-close,
.profession-chart-details-close {
    cursor: pointer;
    position: absolute;
    top: 16px;
    right: 8px;
}

</style>
